export type TFont = 'f1' | 'f2' | 'f3' | 'f4' | 'f5' | 'f6' | 'f7' | 'f8';

export type TTypography = {
  input?: TFont;
  label?: TFont;
  labelWeight?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
};

export const DEFAULT_TYPOGRAPHY: TTypography = {
  input: 'f3',
  label: 'f3',
  labelWeight: 400,
};

export const createTypography = (customTypography?: TTypography) =>
  customTypography ?? DEFAULT_TYPOGRAPHY;
